import { Component, For } from 'solid-js'
import { characterStore, i18nStore } from '../../store'
import { A } from '@solidjs/router'
import { Plus, Download, LayoutGrid } from 'lucide-solid'
import { getAssetUrl } from '../../shared/util'

const WorkshopPage: Component = () => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const chars = characterStore((s) => ({ list: s.characters.list }))

  return (
    <div class="flex flex-col gap-6 p-4">
      <div class="flex items-center justify-between">
        <h1 class="text-2xl font-bold">{i18n.t.workshop_title}</h1>
        <div class="flex gap-2">
          <A href="/editor" class="flex items-center gap-2 rounded-lg bg-[var(--hl-500)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--hl-600)]">
            <Plus size={18} />
            {i18n.t.workshop_create_character}
          </A>
          <A href="/character/import" class="flex items-center gap-2 rounded-lg bg-[var(--bg-700)] px-4 py-2 text-sm font-medium hover:bg-[var(--bg-600)]">
            <Download size={18} />
            {i18n.t.workshop_import_character}
          </A>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex items-center gap-2 border-b border-[var(--bg-700)] pb-2 text-[var(--hl-500)]">
          <LayoutGrid size={20} />
          <span class="font-bold">{i18n.t.workshop_my_characters}</span>
        </div>

        <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
          <For each={chars.list}>
            {(char) => (
              <A href={`/character/${char._id}/chats`} class="group relative flex flex-col overflow-hidden rounded-xl bg-[var(--bg-800)] border border-[var(--bg-700)] transition-all hover:border-[var(--hl-500)]">
                <div class="aspect-square w-full overflow-hidden">
                  <img 
                    src={getAssetUrl(char.avatar || '')} 
                    alt={char.name}
                    class="h-full w-full object-cover transition-transform group-hover:scale-110"
                  />
                </div>
                <div class="p-3">
                  <div class="truncate text-sm font-bold">{char.name}</div>
                  <div class="mt-1 truncate text-xs text-[var(--bg-400)]">{char.description || 'No description'}</div>
                </div>
              </A>
            )}
          </For>
        </div>
      </div>
    </div>
  )
}

export default WorkshopPage



